import React from 'react';
import { ApplicationView, useController } from '@aha-app/mvc';
import RecordPickerController from '../controllers/RecordPickerController';
import RecordIcon from 'components/common/RecordIcon';

const Selection: React.FC = () => {
  const controller = useController(RecordPickerController);
  const { selection, multipleRecords } = controller.state;

  return (
    <div
      className='tw-flex tw-flex-col tw-gap-2'
      style={{
        width: 200,
      }}
    >
      <h4 className='h-700 mt-1 mb-5' style={{ minHeight: 30 }}>
        Selected record{multipleRecords ? 's' : ''}
      </h4>

      {selection.map(result => {
        const { name, searchable, searchableIdentifier } = result;

        return (
          <div
            key={searchableIdentifier}
            className='tw-flex tw-flex-row tw-items-center tw-gap-2'
          >
            <aha-button
              size='mini'
              onClick={() => controller.actionRemoveRecordFromSelection(result)}
            >
              <i className='fa-regular fa-minus' />
            </aha-button>
            {searchable && (
              // We need the <span> to avoid flex box resizing the icon
              <span>
                <RecordIcon record={searchable} />
              </span>
            )}
            <span className='tw-truncate tw-grow '>
              {searchable &&
              'referenceNum' in searchable &&
              searchable.referenceNum
                ? searchable.referenceNum
                : name}
            </span>
          </div>
        );
      })}
    </div>
  );
};

export default ApplicationView(Selection);
